"use strict";
/**
 * Admin routes
 */
/* tslint:disable */
module.exports = [
    {
        path: '/admin/users',
        component: function () { return import(/* webpackChunkName: "admin" */ 'Views/Admin/Users/Users.vue'); },
        meta: {
            requiresAuth: true,
            title: 'User Management',
        },
    },
    {
        path: '/admin/users/salesforce/:sfid',
        component: function () { return import(/* webpackChunkName: "admin" */ 'Views/Admin/Users/Users.vue'); },
        meta: {
            requiresAuth: true,
            title: 'User Management',
        },
    },
    {
        path: '/admin/users/search/:term',
        component: function () { return import(/* webpackChunkName: "admin" */ 'Views/Admin/Users/Users.vue'); },
        meta: {
            requiresAuth: true,
            title: 'User Management',
        },
    },
    {
        path: '/admin/users/status/:status',
        component: function () { return import(/* webpackChunkName: "admin" */ 'Views/Admin/Users/Users.vue'); },
        meta: {
            requiresAuth: true,
            title: 'User Management',
        },
    },
    {
        path: '/admin/adventure-travel',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Admin',
        },
    },
    {
        path: '/admin/adventure-travel/destination-showcase',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/DestinationShowcase/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Destination Showcase Admin',
        },
    },
    {
        path: '/admin/adventure-travel/destination-showcase/new',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/DestinationShowcase/New/New.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Destination Showcase Admin',
        },
    },
    {
        path: '/admin/adventure-travel/destination-showcase/:id',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/DestinationShowcase/Single/Single.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Destination Showcase Admin',
        },
    },
    {
        path: '/admin/adventure-travel/destinations',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Destinations/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Destinations Admin',
        },
    },
    {
        path: '/admin/adventure-travel/destinations/new',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Destinations/New/New.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Destinations New',
        },
    },
    {
        path: '/admin/adventure-travel/destinations/:id',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Destinations/Single/Single.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Destinations Admin',
        },
    },
    {
        path: '/admin/adventure-travel/activities',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Activities/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Activities Admin',
        },
    },
    {
        path: '/admin/adventure-travel/activities/new',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Activities/New/New.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Activities New',
        },
    },
    {
        path: '/admin/adventure-travel/activities/:id',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Activities/Single/Single.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Activities Admin',
        },
    },
    {
        path: '/admin/adventure-travel/homepage-rotator',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/HomepageRotator/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Homepage Rotator Admin',
        },
    },
    {
        path: '/admin/adventure-travel/homepage-rotator/:id',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/HomepageRotator/Edit/Edit.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Homepage Rotator Admin',
        },
    },
    {
        path: '/admin/adventure-travel/the-way',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/TheWay/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel The Way',
        },
    },
    {
        path: '/admin/adventure-travel/the-way/new',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/TheWay/New/New.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel The Way',
        },
    },
    {
        path: '/admin/adventure-travel/the-way/:id',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/TheWay/Edit/Edit.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel The Way',
        },
    },
    {
        path: '/admin/adventure-travel/advocate',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Advocate/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel The Advocate',
        },
    },
    {
        path: '/admin/adventure-travel/photos',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Photo/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Photos',
        },
    },
    {
        path: '/admin/adventure-travel/videos',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Video/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Videos',
        },
    },
    {
        path: '/admin/adventure-travel/tour-operators',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/TourOperators/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Tour Operators',
        },
    },
    {
        path: '/admin/adventure-travel/tour-operators/:id',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/TourOperators/Edit/Edit.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Tour Operators',
        },
    },
    {
        path: '/admin/adventure-travel/travel-advisors',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/TravelAdvisors/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Travel Advisors',
        },
    },
    {
        path: '/admin/adventure-travel/travel-advisors/:id',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/TravelAdvisors/Edit/Edit.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Travel Advisors',
        },
    },
    {
        path: '/admin/adventure-travel/users',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Users/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Users',
        },
    },
    {
        path: '/admin/adventure-travel/users/:username',
        component: function () { return import(/* webpackChunkName: "admin-adventure-travel" */ 'Views/Admin/AdventureTravel/Users/Single/Single.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Adventure.Travel Users',
        },
    },
];
/* tslint:enable */



// WEBPACK FOOTER //
// ./~/ts-loader??ref--3!./src/js/Router/Routes/Admin.ts